/**
 * IceShock — Who Is It For
 * Vanilla JS only. No dependencies.
 * Handles: scroll-reveal entrance, keyboard focusability, theme-editor re-init.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.iceshock-wif';
  var CARD_SELECTOR = '.iceshock-wif__card';

  function initSection(section) {
    if (!section || section.dataset.wifInit === 'true') return;
    section.dataset.wifInit = 'true';

    var cards = section.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    cards.forEach(function (card, index) {
      // Make cards keyboard-focusable so hover styles are reachable via focus-visible.
      if (!card.hasAttribute('tabindex')) {
        card.setAttribute('tabindex', '0');
      }

      // Stagger a subtle entrance animation.
      card.style.transitionDelay = (index * 60) + 'ms';
      card.classList.add('iceshock-wif__card--pending');
    });

    revealOnScroll(section, cards);
  }

  function revealOnScroll(section, cards) {
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.remove('iceshock-wif__card--pending');
        card.classList.add('iceshock-wif__card--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.remove('iceshock-wif__card--pending');
            entry.target.classList.add('iceshock-wif__card--visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Shopify theme editor support: re-init when this section is added/re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      var section = event.target.querySelector(SECTION_SELECTOR);
      if (section) {
        section.dataset.wifInit = 'false';
        initSection(section);
      }
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target && event.target.querySelector) {
      var section = event.target.querySelector(SECTION_SELECTOR);
      if (section) {
        section.classList.remove('iceshock-wif__card--pending');
      }
    }
  });
})();